import React, {useEffect, useMemo} from "react";
import {
    DataGrid,
    GridColDef
} from "@mui/x-data-grid";
import {IDashboardAggregatorNotes} from "./DashboardTypes";
import {FaRegCircleCheck, FaRegCircleXmark} from "react-icons/fa6";
import {PiMicrosoftExcelLogo} from "react-icons/pi";


interface NotesCardProps {
    notes: IDashboardAggregatorNotes[]
}

export const NotesCard : React.FC<NotesCardProps> = ({notes}) => {


    const columns: GridColDef<IDashboardAggregatorNotes>[] = useMemo( () => [
        // { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'name',
            headerName: 'Text',
            width: 600,
            editable: false,
        },
        {
            field: 'type',
            headerName: 'Typ',
            width: 150,
            editable: false,
            renderCell: params => {
                if(params.row.type === 'Mangel') {
                    return <label style={{fontWeight: 'bold', color:'red'}}>Mangel</label>
                } else {
                    return <label>Hinweis</label>
                }
            }
        },
        {
            field: 'isPredefined',
            headerName: 'Text vorhanden',
            width: 150,
            align: 'center',
            renderCell: params => {
                if(params.row.isPredefined) {
                    return <FaRegCircleCheck style={{fontSize: '30px', color: 'green'}} />
                } else {
                    return  <FaRegCircleXmark style={{fontSize: '30px', color: 'red'}} />;
                }
            },
            editable: false,
        },
        {
            field: 'count',
            headerName: 'Anzahl',
            width: 150,
            editable: false,
        }
    ], []);

    return (
        <>
            <DataGrid getRowId={row => row.name}
                      columns={columns}
                      rows={notes}
                      density={'compact'}
                      // slots={{ footer: () => <CustomDashboardDataGridFooter notesExcel={notesExcel} />,
                      //     toolbar: () => <CustomDashboardDataGridToolbar heading={'Übersicht Texte Hinweise/Mängel'} />}}

                      initialState={{
                          sorting: {
                              sortModel: [{ field: 'count', sort: 'desc' }],
                          },
                          // pagination: {
                          //     paginationModel: { pageSize: 5, page: 0 },
                          // },
                      }}
                      sx={{
                          "& .MuiDataGrid-columnHeaders": {
                              backgroundColor: "#fff",
                              color: "#000",

                              fontSize: 14,
                              fontWeight: '500 !!!important',
                              '--unstable_DataGrid-headWeight': 600
                          },
                      }}
            >
            </DataGrid>
        </>
    )
}

// export interface CustomDashboardDataGridToolbarProps {
//     heading: string
// }
// export const CustomDashboardDataGridToolbar: React.FC<CustomDashboardDataGridToolbarProps> = ({heading}) =>  {
//     return (
//         <GridToolbarContainer style={{display: 'flex', placeContent: 'center'}}>
//             <h2 style={{textAlign: 'center'}}>{heading}</h2>
//         </GridToolbarContainer>
//     );
// }
//
// export interface CustomDashboardDataGridFooterProps {
//     notesExcel: string
// }
// export const CustomDashboardDataGridFooter : React.FC<CustomDashboardDataGridFooterProps> = ({notesExcel}) => {
//     return (
//         <GridFooterContainer>
//             {/* Add what you want here */}
//             <Button sx={{marginLeft: '10px'}} variant={"contained"}
//                     color={'success'} startIcon={<SiMicrosoftexcel style={{marginLeft: '10px', marginRight: '10px'}}
//             />}
//                     onClick={() => {
//                         BfARefineUtils.downloadNotes(notesExcel)
//                     }}
//             ><b>Download</b></Button>
//             <Box sx={{ flexGrow: 1 }} />
//             <GridFooter sx={{
//                 border: 'none', // To delete double border.
//             }} />
//         </GridFooterContainer>
//     );
// }